module.exports = __webpack_public_path__ + "common/icon-edit-accent-f62680ec7fa515ce797c8b09d68a44ba.svg";